<template>
  <div>
    <ClientsFilters />
    <TolAlert v-if="tolAlert" v-bind="tolAlert" />
    <ClientsActions />
    <tol-table
      :table-data="clientsList"
      :columns="clientsListingColumns"
      :is-row-clickable="true"
      @row-click="handleRowClick($event)"
    >
      <template v-slot:tableHeader>
        <th-sortable
          :direction="clientsSortField === 'name' ? clientsSortDirection : 'none'"
          field-name="name"
          @change="onSortOrderChange"
          >{{ $t('clients.listing.labels.name') }}</th-sortable
        >
        <th-sortable
          :direction="clientsSortField === 'address_id' ? clientsSortDirection : 'none'"
          field-name="address_id"
          @change="onSortOrderChange"
          >{{ $t('clients.listing.labels.address') }}</th-sortable
        >
        <th-sortable
          :direction="clientsSortField === 'phone' ? clientsSortDirection : 'none'"
          field-name="phone"
          @change="onSortOrderChange"
          >{{ $t('clients.listing.labels.phone') }}</th-sortable
        >
        <th-sortable
          :direction="clientsSortField === 'credit_check' ? clientsSortDirection : 'none'"
          field-name="credit_check"
          @change="onSortOrderChange"
          >{{ $t('clients.listing.labels.credit_check') }}</th-sortable
        >
        <th-sortable
          :direction="clientsSortField === 'type' ? clientsSortDirection : 'none'"
          field-name="type"
          @change="onSortOrderChange"
          >{{ $t('clients.listing.labels.type') }}</th-sortable
        >
      </template>
      <template v-slot:reference_number="{ value }">
        <router-link :to="value.reference_number">{{ value.reference_number }}</router-link>
      </template>
      <template v-slot:phone="{ value }">
        <font-awesome-icon v-if="value.phone" icon="phone-square" />
        {{ value.phone ? value.phone : 'None' }}
      </template>
      <template v-slot:credit_check="{ value }">
        <font-awesome-icon v-if="value.credit_check" icon="calendar-alt" />
        {{ value.credit_check ? value.credit_check : 'None' }}
      </template>
      <template v-slot:address="{ value }">
        <tol-address v-if="value.address" :address="value.address" />
      </template>
      <template v-slot:type="{ value }">
        {{ value.type | readable | capitalize }}
      </template>
    </tol-table>
    <Pagination
      :records-per-page="clientsRecordsPerpage"
      :offset="clientsRecordsOffset"
      :record-count="clientsRecordsCount"
      @change="onChangePaginationParams($event)"
    />
  </div>
</template>
<script>
import TolTable from '@/app/components/TolTable';
import TolAlert from '@/app/components/TolAlert';
import TolAddress from '@/app/components/TolAddress';
import Pagination from '@/app/components/Pagination';
import { AppActions } from '@/app/app.keys';
import ThSortable from '@/app/components/ThSortable';
import { mapGetters } from 'vuex';
import {
  ClientsListingGetters,
  ClientsListingActions
} from '@/app/features/clients/features/clients-listing/clients-listing.keys';
import ClientsFilters from '@/app/features/clients/features/clients-listing/components/ClientsFilters';
import ClientsActions from '@/app/features/clients/features/clients-listing/components/ClientsActions';
export default {
  components: {
    TolTable,
    TolAlert,
    Pagination,
    ThSortable,
    ClientsFilters,
    TolAddress,
    ClientsActions
  },
  computed: {
    ...mapGetters([
      ClientsListingGetters.ClientsList,
      ClientsListingGetters.ClientsRecordsPerPage,
      ClientsListingGetters.ClientsRecordsOffset,
      ClientsListingGetters.ClientsRecordsCount,
      ClientsListingGetters.ClientsSortField,
      ClientsListingGetters.ClientsSortDirection
    ]),
    currentUser() {
      return this.$store.state.currentUser;
    },
    currentPage() {
      return this.$store.getters[ClientsListingGetters.ClientsRecordsOffset];
    },
    clientsListingColumns() {
      return ['name', 'address', 'phone', 'credit_check', 'type'];
    },
    tolAlert() {
      return false;
    }
  },
  mounted() {
    this.$store.dispatch(AppActions.SetPageTitle, this.$t('clients.listing.title'));
    this.$store.dispatch(ClientsListingActions.RetrieveClientsList);
  },
  methods: {
    onChangePaginationParams(event) {
      this.$store.dispatch(ClientsListingActions.PaginationParametersUpdate, event);
    },
    onSortOrderChange(sortOrder) {
      this.$store.dispatch(ClientsListingActions.SortingParametersUpdate, sortOrder);
    },
    onClientsFilterChange(clientsFilterPreference) {
      this.$store.dispatch(
        ClientsListingActions.ClientsFilterPreferenceUpdate,
        clientsFilterPreference
      );
    },
    onClientsTypeFilterChange(clientsTypeFilterPreference) {
      this.$store.dispatch(
        ClientsListingActions.ClientsTypeFilterPreferenceUpdate,
        clientsTypeFilterPreference
      );
    },
    handleRowClick(evt) {
      this.$router.push(`/clients/${evt.reference_number}`);
    }
  }
};
</script>
